import { render, staticRenderFns } from "./TemplateDraftListingItem.vue?vue&type=template&id=bbd81a3c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateDraftListingItem.vue?vue&type=script&lang=js&"
export * from "./TemplateDraftListingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbd81a3c')) {
      api.createRecord('bbd81a3c', component.options)
    } else {
      api.reload('bbd81a3c', component.options)
    }
    module.hot.accept("./TemplateDraftListingItem.vue?vue&type=template&id=bbd81a3c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('bbd81a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Listings/TemplateDraftListingItem.vue"
export default component.exports